import React from "react";

import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { variationUseMutation } from "../hooks";
import VariationForms from "../forms";
import
{
  EntityRemoveButton,
  Localize,
  ModalStandard,
} from "components/service";
import { localizeByKey } from "components/service/localize";
import { TVariation } from "../helpers/variation-types-helper";
import Icons from "components/icons";
import { usePermissionByObject } from "components/permissions";
import Equipment from "components/equipment";


interface IVariationActionFieldProps
{
  variation: TVariation | undefined;
  variables: Record<string, any>;
}


const VariationActionField: React.FC<IVariationActionFieldProps> = ({ variation, variables }) =>
{
  const { _setMutationVariationDelete, loadingMutationVariationDelete } =
    variationUseMutation.delete(variation?.id);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Equipment.Const.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(Equipment.Const.permissions.DELETE);

  const items = [
    {
      key: "1",
      label: (
        <Tooltip
          title={!hasUpdatePermission ? `${localizeByKey('PERMISSION.Error_AccessDenied')}: ${localizeByKey(Equipment.Const.permissions.UPDATE.slug)}` : undefined}
        >
          <ModalStandard
            width={500}
            extraClass={"modal-form"}
            modalButton={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: 100,
                  opacity: hasUpdatePermission ? 1 : 0.5,
                  pointerEvents: hasUpdatePermission ? 'auto' : 'none'
                }}
                onClick={(e) => {
                  if (!hasUpdatePermission) {
                    e.preventDefault();
                    e.stopPropagation();
                  }
                }}
              >
                <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
              </span>
            }
            modalTitle={
              <strong className="modal-title">
                <span className="text">
                  <Localize>FORMS.Title_EditVariation</Localize>
                </span>
              </strong>
            }
          >
            <VariationForms.Edit
              action={() => { }}
              groupID={variation?.equipment_group ?? ""}
              variation={variation}
              variables={variables}
            />
          </ModalStandard>
        </Tooltip>
      ),
      disabled: !hasUpdatePermission,
    },
    {
      key: "2",
      label: (
        <Tooltip
          title={!hasDeletePermission ? `${localizeByKey('PERMISSION.Error_AccessDenied')}: ${localizeByKey(Equipment.Const.permissions.DELETE.slug)}` : undefined}
        >
          <EntityRemoveButton
            modalButton={
              <span style={{
                display: "flex",
                alignItems: "center",
                width: 100,
                opacity: hasDeletePermission ? 1 : 0.5
              }}>
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={
              localizeByKey("ENTITY.Modal_Title_Variation")
            }
            dataNameEntity={variation?.title}
            loading={loadingMutationVariationDelete}
            deleteMutation={(options) => {
              if (!hasDeletePermission) {
                return Promise.reject(new Error('Access denied'));
              }
              return _setMutationVariationDelete(options);
            }}
            variables={{
              id: variation?.id,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default VariationActionField;
